export default "__VITE_ASSET__Ca0hIr_l__"